import { BooleanColumn, StringColumn } from 'baseui/data-table';
import { CustomDateColumn } from 'commons-ui';

export const COL_NAMES = {
	constraintId: 'constraintId',
	isActive: 'isActive',
	featureType: 'featureType',
	paymentMode: 'paymentMode',
	pgName: 'pgName',
	instrumentType: 'instrumentType',
	cardType: 'cardType',
	network: 'network',
	issuer: 'issuer',
	downtimeType: 'downtimeType',
	message: 'message',
	createdBy: 'createdBy',
	emailId: 'emailId',
	begin: 'begin',
	end: 'end'
};

export const columnConfigs = [
	StringColumn({
		title: 'constraint Id',
		mapDataToValue: (data: any) => data[COL_NAMES.constraintId] || '',
		maxWidth: 200
	}),
	BooleanColumn({
		title: 'isActive',
		mapDataToValue: (data: any) => data[COL_NAMES.isActive],
		maxWidth: 200
	}),
	StringColumn({
		title: 'Feature Type',
		mapDataToValue: (data: any) => data[COL_NAMES.featureType] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Payment Mode',
		mapDataToValue: (data: any) => data[COL_NAMES.paymentMode] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'PG Name',
		mapDataToValue: (data: any) => data[COL_NAMES.pgName] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Instrument Type',
		mapDataToValue: (data: any) => data[COL_NAMES.instrumentType] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Card Type',
		mapDataToValue: (data: any) => data[COL_NAMES.cardType] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Network',
		mapDataToValue: (data: any) => data[COL_NAMES.network] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Issuer',
		mapDataToValue: (data: any) => data[COL_NAMES.issuer] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Downtime Type',
		mapDataToValue: (data: any) => data[COL_NAMES.downtimeType] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Message',
		mapDataToValue: (data: any) => data[COL_NAMES.message] || '',
		maxWidth: 400
	}),
	StringColumn({
		title: 'Created By',
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Email Id',
		mapDataToValue: (data: any) => data[COL_NAMES.emailId] || '',
		maxWidth: 200
	}),
	CustomDateColumn({
		title: 'Begin',
		minWidth: 200,
		maxWidth: 200,
		columnName: COL_NAMES.begin
	}),
	CustomDateColumn({
		title: 'End',
		minWidth: 200,
		maxWidth: 200,
		columnName: COL_NAMES.end
	})
];
